import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { dateAndTime } from '../../utils';
import { Button, Background, TabTypes } from '../../Components/index';
import classes from './homepage.css';

class Homepage extends PureComponent {
  state = {
    error: null,
    pageLocation: '',
  };

  containerRef = React.createRef();

  componentDidMount() {
    const { location } = this.props;
    this.setState({ pageLocation: this.determineDep() });
    if (location.state && location.state.error) {
      this.setState({ error: location.state.error });
      this.timer = setTimeout(() => {
        this.setState({ error: null });
      }, 2000);
    }
  }

  componentDidUpdate(prevProps) {
    const { rooms, history } = this.props;
    // If the user creates a temporary room // redirect them once its been created
    if (Object.keys(prevProps.rooms).length < Object.keys(rooms).length) {
      const currentRooms = Object.keys(rooms).map((id) => rooms[id]);
      const prevRooms = Object.keys(prevProps.rooms).map(
        (id) => prevProps.rooms[id]
      );
      const room = currentRooms.filter((rm) => !prevRooms.includes(rm));
      if (room[0]._id && rooms[room[0]._id].tempRoom) {
        // THIS IS HACKY
        history.push(`myVMT/explore/${room[0]._id}`);
      }
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  determineDep = () => {
    const url = window.location.href;
    if (url.split('.')[0] === 'https://vmt-test') {
      return 'staging';
    }
    if (process.env.NODE_ENV === 'development') {
      return 'development';
    }
    return 'production';
  };

  determineMaintWindow = (win) => {
    const { pageLocation } = this.state;
    if (pageLocation === 'development') {
      return `VMT is in development and updated reguarly${
        win ? `: maintenance window is ${win}` : ''
      }, please contact if uptime is required.`;
    }
    if (pageLocation === 'staging') {
      return 'Staging deployment may have unplanned maintenance, please notify if an uptime window is required.';
    }
    return null;
  };

  createRoom = () => {
    const { user, createRoom } = this.props;
    const room = {
      name: 'temp room',
      tempRoom: true,
      creator: user._id || null,
    };
    if (user._id) {
      room.members = [{ user: user._id, role: 'facilitator' }];
    }
    createRoom(room);
  };

  scrollToDomRef = () => {
    window.scroll({
      top: this.containerRef.current.offsetTop - 100,
      left: 0,
      behavior: 'smooth',
    });
  };

  render() {
    const { history, user } = this.props;
    const { error, pageLocation } = this.state;
    // hoisting for easy access to update @TIMESTAMP and for @todo later streamlining
    const dateStamp = (
      <p>
        {`Last updated: ${dateAndTime.toDateString(
          process.env.REACT_APP_BUILD_DATE || '07/24/2022'
        )}, ${process.env.REACT_APP_VERSION}`}
      </p>
    );

    const maintWindow = 'Sunday, 3-7pm EST';
    return (
      <Fragment>
        <Background bottomSpace={null} />
        <div className={classes.Main}>
          <section className={classes.Top}>
            {error ? <div className={classes.Error}>{error}</div> : null}
            <p className={classes.Blurb}>
              Espaces de travail collaboratifs pour explorer le monde des
              mathématiques
            </p>

            <div className={classes.WorkspaceButton}>
              <Button
                theme="Big"
                click={() => {
                  history.push('/login');
                }}
              >
                {user._id ? 'Entrer' : 'Se connecter à VMT'}
              </Button>
            </div>

          </section>

          <section className={classes.Options} ref={this.containerRef} />
        </div>
      </Fragment>
    );
  }
}

Homepage.propTypes = {
  user: PropTypes.shape({ _id: PropTypes.string }),
  location: PropTypes.shape({
    state: PropTypes.shape({ error: PropTypes.string }),
  }),
  history: PropTypes.shape({ push: PropTypes.func }).isRequired,
  createRoom: PropTypes.func.isRequired,
  rooms: PropTypes.shape({}),
};

Homepage.defaultProps = {
  user: null,
  rooms: null,
  location: null,
};

export default Homepage;



// WEBPACK FOOTER //
// ./src/Layout/Homepage/Homepage.js